import { Card } from "@/components/ui/card";
import { Building2, Calendar, DollarSign, Users } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const DashboardMetrics = () => {
  const { data: metrics } = useQuery({
    queryKey: ["host-dashboard-metrics"],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error("Not authenticated");

      // Get total properties
      const { data: properties } = await supabase
        .from("properties")
        .select("id")
        .eq("host_id", user.id);

      // Get active bookings
      const { data: activeBookings } = await supabase
        .from("bookings")
        .select("id, total_price")
        .eq("status", "confirmed")
        .gte("check_out_date", new Date().toISOString().split('T')[0]);

      // Get total revenue
      const { data: revenue } = await supabase
        .from("host_guest_payments")
        .select("amount")
        .eq("host_id", user.id)
        .eq("status", "completed");

      return {
        totalProperties: properties?.length || 0,
        activeBookings: activeBookings?.length || 0,
        totalRevenue: revenue?.reduce((sum, payment) => sum + Number(payment.amount), 0) || 0,
        occupancyRate: activeBookings?.length ? 
          ((activeBookings.length / (properties?.length || 1)) * 100).toFixed(1) : 0
      };
    }
  });

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
      <Card className="p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-500">Total Properties</p>
            <p className="text-2xl font-bold">{metrics?.totalProperties}</p>
          </div>
          <Building2 className="h-8 w-8 text-gray-400" />
        </div>
      </Card>

      <Card className="p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-500">Active Bookings</p>
            <p className="text-2xl font-bold">{metrics?.activeBookings}</p>
          </div>
          <Calendar className="h-8 w-8 text-gray-400" />
        </div>
      </Card>

      <Card className="p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-500">Total Revenue</p>
            <p className="text-2xl font-bold">
              ${metrics?.totalRevenue.toLocaleString()}
            </p>
          </div>
          <DollarSign className="h-8 w-8 text-gray-400" />
        </div>
      </Card>

      <Card className="p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-500">Occupancy Rate</p>
            <p className="text-2xl font-bold">{metrics?.occupancyRate}%</p>
          </div>
          <Users className="h-8 w-8 text-gray-400" />
        </div>
      </Card>
    </div>
  );
};